import React, { useState, useEffect, useCallback } from 'react';

//Queries
import tokenAdminMX from '../Queries/tokenAdminMX';
import getAdminCarritoMX from '../Queries/getAdminCarritoMX';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

// Styles
import styles from './index.module.sass';
import postAdminCarritoMX from '../Queries/postAdminCarritoMX';

export default function EntregaPedidosCedis(props) {
  const { setOptionSelected, setSectionName, getCookie } = props;

  const [fechaEntrega, setfechaEntrega] = useState('');
  const [loading, setloading] = useState(false);

  const changeValue = (e) => {
    setfechaEntrega(e.target.value);
  };

  const getFechaEntrega = useCallback(async () => {
    setloading(true);
    try {
      // Obtener el token
      const tokenResponse = await tokenAdminMX({
        tmbservice: 'WebApiLoginMX/api/login/administracion',
      });

      const {
        codigoMensaje: tokenCodigo,
        mensajeEsp: tokenMensaje,
        data: tokenData = {},
      } = tokenResponse;

      const now = new Date();
      const expireTime = now.getTime() + 1000 * 36000;
      now.setTime(expireTime);
      document.cookie = `TokenApiAdminMX=${
        tokenData.tokenLogin
      };expires=${now.toUTCString()};path=/`;

      if (tokenCodigo === 200) {
        // Obtener el cuestionario después de tener el token
        const parametro = await getAdminCarritoMX({
          tmbservice: 'WebApiAdminCarritoMX/api/general/obtenParametro',
          jsonBody: {
            clave: 'FechaPedido',
          },
          token: tokenData.tokenLogin,
        });

        const { codigoMensaje, mensajeEsp, data } = parametro;

        if (codigoMensaje === 200) {
          const [day, month, year] = data.split('/');
          const formattedDate = `${year}-${month}-${day}`;
          setfechaEntrega(formattedDate);
          console.log(data, 'DATA');
        } else {
          alert(mensajeEsp);
        }
      } else {
        console.log(tokenMensaje, 'Admin');
      }
    } catch (error) {
      console.error('Error al obtener el token o la FEchga:', error);
    }
    setloading(false);
  }, []);

  useEffect(() => {
    getFechaEntrega();
  }, [getFechaEntrega]);

  useEffect(() => {
    setOptionSelected('entregaPedidosCedis');
    setSectionName('Configuración de fecha para entregas de pedidos en CEDIS');
  }, [setOptionSelected, setSectionName]);

  async function guardarFecha() {
    setloading(true);
    const [year, month, day] = fechaEntrega.split('-');

    const formattedDateSubmit = `${day}/${month}/${year}`;

    const parametro = await postAdminCarritoMX({
      tmbservice: `WebApiAdminCarritoMX/api/general/ActualizaParametro?clave=FechaPedido&valor=${formattedDateSubmit.toString()}`,
      jsonBody: {},
      token: '',
      getCookie,
    });

    const { codigoMensaje, mensajeEsp } = parametro;

    if (codigoMensaje === 200) {
      alert('La fecha se ha actualizado exitosamente');
    } else {
      alert(mensajeEsp);
    }
    setloading(false);
  }

  return (
    <div>
      <div className={styles.title}>
        Ingresa la fecha en la que entregaran pedidos para los CEDIS
      </div>
      <div className={styles.inputs}>
        <input
          type='date'
          className={styles.inputText}
          name='fechaPedido'
          id='fechaPedido'
          value={fechaEntrega}
          placeholder='La Fecha actual es:'
          onChange={(e) => changeValue(e)}
        />
      </div>
      <div className={styles.buttonContainer}>
        <Button
          onClick={() => {
            if (!loading) guardarFecha();
          }}
          color='primary'
          variant='contained'
          size='large'
          className={styles.button}>
          {loading ? <CircularProgress className={styles.circularProgress} /> : 'Guardar fecha'}
        </Button>
      </div>
    </div>
  );
}
